import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {AlertService, AuthenticationService, TenantService, UserService} from "../../_services";
import {LoginHelper, Role} from "../../helpers";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {DictionaryService} from "../../_services/dictionary.service";
import {DictionaryItem} from "../../_models/dictionaryItem";
import {EditDictionaryItemComponent} from "../editDictionaryItem/editDictionaryItem.component";
import {User} from "../../_models";
import {ListMessageComponent} from "../listMessage";
import {ConfirmComponent} from "../confirm";
import { Constants } from "../../helpers/constants";
import { SelectControlItemComponent } from "../selectControlItem/select-control-item.component";
import { FormsModule } from '@angular/forms';
import { DragDropModule } from 'primeng/dragdrop';


@Component({
  standalone: false,
  selector: "dictionary",
  templateUrl: 'dictionary.component.html',
  styleUrls: ['./dictionary.component.scss'],
})

export class DictionaryComponent implements OnInit {
  dictionaryItems: DictionaryItem[];
  topicDictionaryItems: DictionaryItem[];
  findingsNotesDictionaryItems: DictionaryItem[];
  recommendationsDictionaryItems: DictionaryItem[];
  policyContentItems: DictionaryItem[];
  cols: any[] = [
    {'field': 'name', 'header': 'Name'},
    {'field': 'dictionary', 'header': 'Type'},
    {'field': 'details', 'header': 'Details'},
  ];
  topicCols: any[] = [
    {'field': 'name', 'header': 'Topic'},
  ];
  policyContentCols: any[] = [
    {'field': 'topic', 'header': 'Topic'},
    {'field': 'name', 'header': 'Name'},
  ];
  rowGroupMetadata: any = {};
  isImplementationControlStatementsVisible = false;
  currentUser = null;
  expanded = {};
  constants = Constants;

  constructor(
    public router: Router,
    public userService: UserService,
    public dictionaryService: DictionaryService,
    public authenticationService: AuthenticationService,
    public tenantService: TenantService,
    public alertService: AlertService,
    public dialog: MatDialog
  ) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();
      return;
    }
  }

  ngOnInit(): void {
    this.dictionaryService.getAll().subscribe(s => {
      let topicStart = 0;
      this.dictionaryItems = s.filter(s => s.dictionary === 'Vendor' || s.dictionary === 'Service');
      for (let i = 1; i < this.dictionaryItems.length; i++) {
        this.dictionaryItems[i].isFirstTopic = this.dictionaryItems[i].securityTopic !== this.dictionaryItems[i - 1].securityTopic || (this.dictionaryItems[i].dictionary !== this.dictionaryItems[i - 1].dictionary && this.dictionaryItems[i].dictionary === 'Service');
        if (this.dictionaryItems[i].isFirstTopic) {
          topicStart = this.dictionaryItems[i].itemId;
        }
        this.dictionaryItems[i].topicStart = topicStart;
      }
      this.topicDictionaryItems = s.filter(s => s.dictionary === 'Topic');
      this.findingsNotesDictionaryItems = s.filter(s => s.dictionary === 'FindingsNotes');
      this.recommendationsDictionaryItems = s.filter(s => s.dictionary === 'Recommendations');
      this.policyContentItems = s.filter(s => s.dictionary === 'PolicyContent');
      this.updateRowGroupMetaData(this.policyContentItems, 'PolicyContent');
    });
    this.currentUser = this.getCurrentUser();
    this.tenantService.getCurrent().subscribe(p => {
      this.isImplementationControlStatementsVisible = (this.currentUser.role & (Role.KingAdmin | Role.Admin | Role.Support | Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport | Role.PrimaryManager)) != 0 && (!p || p.isImplementationControlStatementsEnabled);
    });
  }

  isMaster() {
    const tenantName = LoginHelper.getTenantName();
    return tenantName == Constants.RiskSpongeMaster;
  }

  edit(item = null) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '90%',
      minWidth: "300px",
      height: '90%',
      data: {
        dictionaryItem: item,
        parents: item.dictionary == 'Vendor' ? '' : this.dictionaryItems.filter(i => i.dictionary == 'Vendor')
      }
    };

    let dialogRef = this.dialog.open(EditDictionaryItemComponent, config);

    dialogRef.afterClosed().subscribe((result: any) => {
      this.ngOnInit();
    });
  }

  dropDictionaryItem(item) {
    this.dictionaryService.isAssigned(item.itemId).subscribe(r => {
      if (r) {
        this.dialog.open(ConfirmComponent, {
          data: {
            title: 'Service is specified on one or more controls, these records will be removed. Do you wish to proceed?',
            yes: 'Yes',
            no: 'No',
            confirm: (isChecked) => this.doDropDictionaryItem(item),
            cancel: () => {
            }
          }
        });
      } else {
        this.doDropDictionaryItem(item);
      }
    });
  }

  doDropDictionaryItem(item) {
    this.dictionaryService.delete(item.itemId).subscribe(() => {
      this.ngOnInit();
    });
  }

  public getCurrentUser(): User {

    return JSON.parse(sessionStorage.getItem('currentUser'));
  }

  ensureDefaultItems() {
    this.dictionaryService.ensureDefaultTopics().subscribe(() => {
      this.ngOnInit();
    })
  }

  import(event, dictionary) {

    this.alertService.clear();

    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.dictionaryService.import(file, dictionary).subscribe(
        (res) => {
          let config: MatDialogConfig = {
            panelClass: 'custom-overlay-pane-class',
            width: 'auto',
            height: '90%',
            data: {
              items: res,

              title: "Import report"
            }
          };
          this.dialog.open(ListMessageComponent, config);
          this.ngOnInit();
        },
        (error) => {
          const errorMessage = 'An error occurred while upload vault items.';
          this.alertService.error(errorMessage);
        });
    }
  }

  importVendors(event) {

    this.alertService.clear();

    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.dictionaryService.importVendors(file).subscribe(
        (res) => {
          let config: MatDialogConfig = {
            panelClass: 'custom-overlay-pane-class',
            width: 'auto',
            height: '90%',
            data: {
              items: res,

              title: "Import report"
            }
          };
          this.dialog.open(ListMessageComponent, config);
          this.ngOnInit();
        },
        (error) => {
          const errorMessage = 'An error occurred while upload control items.';
          this.alertService.error(errorMessage);
        });
    }
  }

  updateRowGroupMetaData(data, dictionary) {
    this.rowGroupMetadata = this.rowGroupMetadata || {};
    this.rowGroupMetadata[dictionary] = this.rowGroupMetadata[dictionary] || {};
    if (data) {
      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let brand = rowData.securityTopic;
        if (i == 0) {
          this.rowGroupMetadata[brand] = {index: 0, size: 1};
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.securityTopic;
          if (brand === previousRowGroup) {
            this.rowGroupMetadata[brand].size++;
          } else
            this.rowGroupMetadata[brand] = {index: i, size: 1};
        }
      }
    }
  }
}
